import store from '../src/store'

/**
 * 登录授权信息配置
 */
const OPEN_CONFIG = {
  wx_app_id: 'wx8a1a23f2da939f31',
  // 登录回调地址
  wx_redirect_uri: 'http://shoptestserver.irematch.com/users/loginAdminWxAuth?appid=10000&redirect_uri=http://shopadmintest.irematch.com/login',
  wx_bind_redirect_uri: 'http://shoptestserver.irematch.com/users/bindWxAuth?appid=10000'
  // wx_bind_redirect_uri: 'http://huabukaii.xicp.io:58003/users/bindWxAuth?appid=10000'
}
/**
 * 用户role类型key
 */
const USER_ROLE_KEY = {
  FRONT: 1, // 前台业务
  FRONT_USER: 10, // 消费者
  FRONT_GROUPER: 11, // 代理人
  FRONT_INCLUDE: [10, 11], // 前台角色包含

  MIDDLE: 2, // 中台业务
  MIDDLE_SUPPLIER: 20, // 供货商
  MIDDLE_DRIVER: 12, // 司机
  MIDDLE_SERVICE: 13, // 服务商
  FRONT_PERSONAL: 14, // 服务商店铺人员
  MIDDLE_AGENT: 15, // 代理商
  MIDDLE_INCLUDE: [20, 12, 13, 15], // 中台角色包含

  ADMIN: 3, // 后台业务
  ADMIN_USER: 30, // 运营人员
  ADMIN_BUYER: 31, // 采购员
  ADMIN_STORE: 32, // 仓库人员
  ADMIN_SORTMEMBER: 33, // 分拣员
  ADMIN_SUPER: 999, // 超级管理员
  ADMIN_INCLUDE: [30, 31, 32, 33, 999] // 后台角色包含
}
const USER_IDENTITYS_DATA = {
  1: '前台业务',
  10: '消费者',
  11: store.state.agentName,

  2: '中台业务',
  20: '供货商',
  12: '司机',
  13: '商家',
  // 14: '商家（商家其他用户）',
  15: '代理商',

  3: '后台业务',
  30: '运营人员',
  31: '采购员',
  32: '仓库人员',
  33: '分拣员',
  999: '超级管理员'
}

/**
 * 禁用状态
 */
const DISABLE_STATE_KEY = {
  DISABLE: 2, // 停用
  ENABLE: 1 // 启用
}

/**
 * 退货的状态
 */
const REFUNDABLE_STATE_KEY = {
  RETURN_GOODS: 1, // 退货
  CHANGE_GOODS: 2, // 换货
  RETURN_ONLY_MONEY: 3 // 仅退款
}

/**
 * 审核状态
 */
const APPLY_STATE_KEY = {
  TO_AUDIT: 10, // 待审核
  SUCCESS_AUDIT: 11, // 审核通过
  FAIL_AUDIT: 12 // 审核失败
}

/**
 * 订单配送方式
 */
const ORDER_DELIVERT_TYPE = {
  DELIVER: 1, // 自提
  POST: 2, // 邮寄
  INSTANT_DELIVERY: 3, // 同城跑腿
  BUSINESS_DELIVERY: 4 // 商家自送
}

/**
 * 订单 状态
 */
const ORDER_STATE_KEY = {
  TO_PAY: 20, // 待支付
  SUCCESS_PAY: 21, // 已支付
  ORDER_PAY_PACK_COMPLETE: 31, // 已打包配送
  TO_RECEIVED: 22, // 待收货
  SUCCESS_RECEIVED: 23, // 已收货（订单完成）
  REFUND: 24, //  发起退货
  REFUND_AUDIT: 25, // 退货审核中
  SUCCESS_REFUND: 26, // 退货通过
  FAIL_REFUND: 27, // 退货失败
  EXPIRE: 28, // 订单失效
  ORDER_DETIAL_RETURN_AGREE: 30, // 子订单退货通过
  ORVER_ORDER: [21, 22, 31, 33, 29], // 已支付订单
  FINISH: 29, // 订单完成
  SETTLEMENT_WAIT: 101, // 服务订单待结算
  SETTLEMENT_FINISH: 102, // 服务订单已结算
  SHARE: 33
}
/** 订单来源类型 */
const ORDER_FROM_TYPE = {
  COMMON: 1, // 普通
  RUSH_PURCHASE: 2, // 秒杀
  LIVING: 3, // 直播
  MAILL_VIDEO: 4, // 小视频
  GROUP: 5, // 拼团
  GROUPER_INDEX: 6, // 团长首页
  GROUPERBUY: 7, // 团长团购
  INTEGRAL: 9, // 积分购
  SHOPBUY: 8 // 商家店铺
}

function getORDER_STATE_VALUE (key) {
  if (key === ORDER_STATE_KEY.TO_PAY) {
    return '待支付'
  }
  if (key === ORDER_STATE_KEY.SHARE) {
    return '待分享'
  }
  if (key === ORDER_STATE_KEY.SUCCESS_PAY) {
    return '已支付'
  }
  if (key === ORDER_STATE_KEY.ORDER_PAY_PACK_COMPLETE) {
    return '已支付'
  }
  if (key === ORDER_STATE_KEY.TO_RECEIVED) {
    return '待收货'
  }
  if (key === ORDER_STATE_KEY.SUCCESS_RECEIVED) {
    return '已收货'
  }
  if (key === ORDER_STATE_KEY.REFUND) {
    return '发起退货'
  }
  if (key === ORDER_STATE_KEY.REFUND_AUDIT) {
    return '退货审核中'
  }
  if (key === ORDER_STATE_KEY.SUCCESS_REFUND) {
    return '退货通过'
  }
  if (key === ORDER_STATE_KEY.ORDER_DETIAL_RETURN_AGREE) {
    return '退货通过'
  }
  if (key === ORDER_STATE_KEY.FAIL_REFUND) {
    return '退货失败'
  }
  if (key === ORDER_STATE_KEY.EXPIRE) {
    return '订单失效'
  }
  if (key === ORDER_STATE_KEY.FINISH) {
    return '订单完成'
  }
  if (key === ORDER_STATE_KEY.SETTLEMENT_WAIT) {
    return '待结算'
  }
  if (key === ORDER_STATE_KEY.SETTLEMENT_FINISH) {
    return '已结算'
  }

  if (key === DISABLE_STATE_KEY.DISABLE) {
    return '停用'
  }
  if (key === DISABLE_STATE_KEY.ENABLE) {
    return '启用'
  }
}

/**
 * 交易记录 状态
 */
const TRADE_STATE_KEY = {
  NO_PAY: 30, // 未支付
  SUCCESS_PAY: 31, // 已支付
  FAIL_PAY: 32, // 支付失败
  SUCCESS_REFUND: 33, // 已退款
  BY_STAGES: 34 // 分期还款中
}

function getTRADE_STATE_VALUE (key) {
  if (key === TRADE_STATE_KEY.NO_PAY) {
    return '未支付'
  }
  if (key === TRADE_STATE_KEY.SUCCESS_PAY) {
    return '已支付'
  }
  if (key === TRADE_STATE_KEY.FAIL_PAY) {
    return '支付失败'
  }
  if (key === TRADE_STATE_KEY.SUCCESS_REFUND) {
    return '已退款'
  }
  if (key === TRADE_STATE_KEY.BY_STAGES) {
    return '分期还款中'
  }

  if (key === DISABLE_STATE_KEY.DISABLE) {
    return '停用'
  }
  if (key === DISABLE_STATE_KEY.ENABLE) {
    return '启用'
  }
}

/**
 * 配送 状态
 */
const DELIVER_STATE_KEY = {
  NO_DISTRIBUTION: 51, // 待配送
  DO_DISTRIBUTION: 52, // 配送中
  SUCCESS_DISTRIBUTION: 53, // 配送完成
  FAIL_DISTRIBUTION: 54, // 配送失败

  PACK_NO: 60, // 未分拣
  PACK_WATI: 61, // 待生成配送单
  PACK_COMPLETE: 62 // 已生成配送单
}

function getDELIVER_STATE_VALUE (key) {
  if (key === DELIVER_STATE_KEY.NO_DISTRIBUTION) {
    return '待配送'
  }
  if (key === DELIVER_STATE_KEY.DO_DISTRIBUTION) {
    return '配送中'
  }
  if (key === DELIVER_STATE_KEY.SUCCESS_DISTRIBUTION) {
    return '配送完成'
  }
  if (key === DELIVER_STATE_KEY.FAIL_DISTRIBUTION) {
    return '配送失败'
  }
  if (key === DELIVER_STATE_KEY.PACK_WATI) {
    return '待生成配送单'
  }
  if (key === DELIVER_STATE_KEY.PACK_COMPLETE) {
    return '已生成配送单'
  }
}

/**
 * 系统配置key
 */
const SETTING_KEY = {
  DISTRIBUTION: 'distribution_key', // 会员分销设置
  GROUPER_DISTRIBUTION: 'grouper_distribution_key', // 分销设置
  GROUPER_OPEN: 'grouper_open_key', // 团长开通
  REGIST_REWARD: 'regist_reward', // 注册奖励配置
  FIRSTORDER_REWARD: 'firstorder_reward', // 首单奖励配置
  VIP_SETTING: 'vip_setting', // VIP配置
  RFM_VALUE_SETTING: 'rfm_value_setting', // RFM值生成规则
  GROUPER_SETTING_DETAIL: 'grouper_setting_detail' // 团长等级规则配置详情
}

/**
 * 日志类型
 */
const LOG_TYPE_KEY = {
  BUSINESS_LOG: 41, //  业务日志
  SERVER_LOG: 42, // 服务端程序日志
  CLIENT_LOG: 43, // 客户端程序日志
  ADMIN_LOG: 44 // 后台管理日志
}

/**
 * 登录平台
 */
const P_LOGIN_TYPE = {
  WX_MINI: 'wx-mini', // 微信小程序
  WX_MINI_GROUPER: 'wx-mini-grouper', // 微信小程序服务商端
  WX_MINI_RETAIL: 'wx-mini-retail', // 微信小程序（悦邻零售）
  ALIPAY_MINI: 'alipay-mini', // 支付宝小程序
  ALIPAY_MINI_GROUPER: 'alipay-mini-grouper', // 支付宝小程序服务商端
  ALIPAY_MINI_RETAIL: 'alipay-mini-retail', // 支付宝小程序（悦邻零售）
  WX_H5: 'wx-h5', // 微信h5
  WX_APP: 'wx-app', // 微信APP登陆
  WX_APP_GROUPER: 'wx-app-grouper', // 微信APP登陆服务商端
  WX_APP_LIVE: 'wx-app-live', // 微信APP登陆 直播端
  APP: 'app', // app登录
  BD_MINI: 'bd-mini', // 百度小程序
  DOUYIN: 'douyin', // 抖音
  ADMIN: 'admin', // 管理端
  ADMIN_AGENT: 'admin-agent', // 城市代理商
  ADMIN_MERCHANT: 'admin-merchant', // 商家
  ADMIN_SUPPLIER: 'admin-supplier', // 供应商
  OTHER: 'other' // 其他
}

/**
 * 平台类型
 */
function getPLATFORM (key) {
  if (key === 'admin') {
    return '管理后台'
  }
  if (key === 'wx-h5') {
    return '微信h5'
  }
  if (key === 'wx-app') {
    return '微信app'
  }
  if (key === 'app') {
    return 'APP'
  }
  if (key === 'wx-mini') {
    return '微信小程序'
  }
  if (key === 'wx-mini-retail') {
    return '微信小程序（悦邻零售）'
  }
  if (key === 'wx-mini-grouper') {
    return '微信小程序（服务商端）'
  }
  if (key === 'alipay-mini') {
    return '支付宝小程序'
  }
  if (key === 'alipay-retail') {
    return '支付宝小程序（悦邻零售）'
  }
  if (key === 'alipay-grouper') {
    return '支付宝小程序（服务商端）'
  }
  if (key === 'wx-app-grouper') {
    return '服务商app'
  }
  if (key === 'wx-app-live') {
    return '直播app'
  }
}

// 差异分拣状态
const DIFF_SORTING_STATUS = {
  NORMAL: 1, // 正常
  DIFF: 2, // 重量/数量变化
  ADD: 3, // 添加商品
  DELETE: 4 // 删除商品
}

// 预分拣状态
const PRESORTING_STATUS = {
  BIND: 10,
  UNBIND: 1
}
// 预分拣状态格式化
function GET_PRESORTING_STATUS_VALUE (key) {
  if (key === PRESORTING_STATUS.BIND) {
    return '已分拣'
  }
  if (key === PRESORTING_STATUS.UNBIND) {
    return '待分拣'
  }
}

export {
  DISABLE_STATE_KEY,
  USER_ROLE_KEY,
  REFUNDABLE_STATE_KEY, // 6689 添加退货的状态
  // USER_ROLE_DATA,
  USER_IDENTITYS_DATA,
  APPLY_STATE_KEY,

  ORDER_STATE_KEY,
  getORDER_STATE_VALUE,
  // 订单类型
  ORDER_DELIVERT_TYPE,
  ORDER_FROM_TYPE,

  TRADE_STATE_KEY,
  getTRADE_STATE_VALUE,

  LOG_TYPE_KEY,

  DELIVER_STATE_KEY,
  getDELIVER_STATE_VALUE,
  OPEN_CONFIG,
  // 系统配置key
  SETTING_KEY,
  getPLATFORM,
  // 登录平台
  P_LOGIN_TYPE,
  // 差异分拣状态
  DIFF_SORTING_STATUS,
  // 预分拣状态
  PRESORTING_STATUS,
  // 预分拣状态格式化
  GET_PRESORTING_STATUS_VALUE
}



//////////////////
// WEBPACK FOOTER
// ./common/const.js
// module id = oc7H
// module chunks = 1